import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var ChevronUpSmall = function ChevronUpSmall(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7364 15.6364C17.3849 15.9879 16.8151 15.9879 16.4636 15.6364L12 11.1728L7.53639 15.6364C7.18492 15.9879 6.61507 15.9879 6.2636 15.6364C5.91213 15.2849 5.91213 14.7151 6.26361 14.3636L11.3636 9.2636C11.7151 8.91213 12.285 8.91213 12.6364 9.26361L17.7364 14.3636C18.0879 14.7151 18.0879 15.2849 17.7364 15.6364Z",
    fill: color
  }));
};

export { ChevronUpSmall };
